import React from "react";
import WebhookIntegration from "../WebhookIntegration";

export default function WebhooksTab() {
  return (
    <div className="-m-6">
      <WebhookIntegration />
    </div>
  );
}
